const body = document.body;
const rect = body.getBoundingClientRect();
let tooltip = document.querySelector(".cursor-tooltip");
const removeCursorTargetElement = document.querySelector("slider-component");

function addCursorAndDescription(e) {
  body.style.cursor =
    "url('https://cdn.shopify.com/s/files/1/0730/4780/2146/files/Vector_3.svg?v=1714752042'), auto";
  tooltip.classList.remove("cursor-tooltip--hidden");
}

function onMouseMove(e) {
  const clientX = e.clientX;
  const clientY = e.clientY;
  const y = clientY;
  tooltip.style.top = y + "px";
  tooltip.style.left = clientX + "px";
}

function removeCursorAndDescription() {
  // Revert cursor to normal
  body.style.cursor = "auto";
  tooltip.classList.add("cursor-tooltip--hidden");
}

// Function to handle mouse enter
function handleMouseEnter() {
  removeCursorAndDescription(); // Example function to add cursor and description
}

// Function to handle mouse leave
function handleMouseLeave(e) {
  // Check if mouse left from above or below
  const rect = removeCursorTargetElement.getBoundingClientRect();
  const mouseY = e.clientY;

  if (mouseY < rect.top) {
    addCursorAndDescription();
    // Perform actions when mouse exits from above
  }
}
addCursorAndDescription();
body.addEventListener("mousemove", (e) => onMouseMove(e));

// Add event listeners
removeCursorTargetElement.addEventListener("mouseenter", handleMouseEnter);
removeCursorTargetElement.addEventListener("mouseleave", handleMouseLeave);
